import Layout from '@/components/layout/Layout';
import { Mail, Globe, ArrowRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function RecursosGratuitos() {
  return (
    <Layout>
      <section className="py-24 bg-white min-h-screen flex items-center">
        <div className="container-custom">
          <div className="bg-secondary/5 rounded-[3rem] p-8 md:p-20 flex flex-col md:flex-row items-center gap-12 border border-secondary/10 relative overflow-hidden shadow-2xl">
             {/* Decoración */}
             <div className="absolute top-0 right-0 p-12 opacity-5">
               <Globe className="w-64 h-64" />
             </div>

             <div className="flex-1 space-y-6 relative z-10">
                <span className="inline-block bg-accent/20 text-accent px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide">
                  Recurso Exclusivo
                </span>
                <h1 className="text-4xl md:text-6xl font-serif text-primary leading-tight">
                  Descarga nuestra <span className="text-secondary italic">Guía Maestra 2026</span>
                </h1>
                <p className="text-xl text-muted-foreground max-w-xl">
                  Hemos resumido 20 años de experiencia en 50 páginas con consejos prácticos, destinos secretos y cómo planificar el viaje perfecto sin perder exclusividad. 
                </p>
                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <Input 
                    type="email" 
                    placeholder="Tu mejor email..." 
                    className="h-14 rounded-xl border-slate-200 focus:border-accent bg-white"
                  />
                  <Button className="h-14 px-8 bg-primary hover:bg-primary/90 text-white rounded-xl transition-all shadow-lg hover:shadow-primary/25 whitespace-nowrap">
                    RECIBIR GUÍA GRATIS
                  </Button>
                </div>
                <p className="text-xs text-muted-foreground">
                  * Al hacer clic aceptas nuestra política de privacidad. No te enviaremos spam, solo inspiración.
                </p>
             </div>
             
             <div className="flex-1 w-full max-w-sm hidden md:block relative z-10">
               <div className="aspect-[3/4] bg-primary rounded-2xl shadow-2xl relative overflow-hidden transform rotate-3 hover:rotate-0 transition-transform duration-500">
                  <img 
                    src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?auto=format&fit=crop&q=80&w=1000" 
                    alt="Guía Maestra de Viajes"
                    className="w-full h-full object-cover opacity-80"
                  />
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8 bg-black/20">
                    <h3 className="text-3xl font-serif text-white font-bold leading-tight uppercase tracking-tighter">
                      GUÍA<br/>MAESTRA<br/>2026
                    </h3>
                    <div className="w-12 h-1 bg-accent my-4" />
                    <p className="text-white/80 text-sm italic">Secretos de un Viajero Experto</p>
                  </div>
               </div>
             </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
